// extracted by mini-css-extract-plugin
export var image = "_hi-1";
export var imageContainer = "_hi-0";